import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { CountryContext } from '../../contexts';
import { countrySelector } from '../../scenes/Account/AccountSelectors';
import { appThemeSelector } from './AppSelectors';
import Theme from '../Theme/Theme';
import themes from '../../shared/style/themes/themes';
import Spinner from '../Spinner/Spinner';
import { initialize } from './AppActions';
import { useSiteRedirect } from './AppHooks';

const App = ({ children, initialized, initialize, country, appTheme }) => {
  useEffect(() => {
    initialize();
  }, [initialize]);

  useEffect(() => {
    if (appTheme === themes.iprofile) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = '/iprofilerisks-favicon.png';
    }
  }, [appTheme]);

  useSiteRedirect();

  if (!initialized) {
    return <Spinner />;
  }

  return (
    <CountryContext.Provider value={{ country }}>
      {appTheme === themes.iprofile && (
        <Helmet>
          <title>{appTheme === themes.iprofile ? 'IProfileRisk' : 'LMI RiskCoach'} </title>
        </Helmet>
      )}
      <Theme>{children}</Theme>
    </CountryContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  initialized: state.app.initialized,
  country: countrySelector(state),
  appTheme: appThemeSelector(state),
});

const mapDispatchToProps = { initialize };

export default connect(mapStateToProps, mapDispatchToProps)(App);
